/**
 * Published account-page addresses, on the site origin.
 *
 * Kept apart from the page modules so `meta.ts` (entry chunk) can name a path
 * without pulling a lazy page's copy into the bundle every visitor downloads.
 */

/**
 * The e-mail-change cancel page (#3549). A PUBLISHED CONTRACT: the function's
 * `CSL_EMAIL_CHANGE_CANCEL_URL` names it and mail already sent keeps pointing
 * here, so it never moves. `routes.ts` registers the same literal and
 * `email-change-cancel.test.ts` resolves this constant through the route table.
 */
export const EMAIL_CHANGE_CANCEL_PATH = "/account/email-change/cancel";
